import type { Message } from '@twilio/conversations';
import { useSound } from 'app/hooks/useSound';
import { useEffect } from 'react';
import NotificationSound from 'app/assets/sound/swiftly.mp3';

import useConversation from './useConversation';
import useTwilioUser from './useTwilioUser';

export function useNotificationSound() {
  const user = useTwilioUser();
  const conversation = useConversation();
  const [notify] = useSound(NotificationSound);

  useEffect(() => {
    const makeSound = (message: Message) => {
      if (message.author === user?.identity) return;
      // @ts-ignore
      if (!message.attributes?.hidden && message.index > 0) {
        notify();
      }
    };

    if (conversation) {
      conversation.on('messageAdded', makeSound);
    }

    return () => {
      conversation?.off('messageAdded', makeSound);
    };
  }, [conversation, notify, user?.identity]);
}
